import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import AppContainer from "../Appcontainer";
import WebtopPreview from "../../webtop/WebtopPreview"; // Webtop redesign — Phase 16 (web parity)
import store from "../../store";
import { Provider } from "react-redux";
import { clearLocalStorageSafe } from "../../databucket";
import Register from "../../views/pages/Authentication/Register";
import Otp from "../../views/pages/Authentication/Otp";
import Error404 from "../../views/pages/Error/Error404";
import Error500 from "../../views/pages/Error/Error500";
import ChangePassword from "../../views/pages/Authentication/ChangePassword";
import ForgotPassword from "../../views/pages/Authentication/ForgotPassword";
import LockScreen from "../../views/pages/Authentication/LockScreen";
import Accordions from "../../views/pages/Ui_Interface/Components/Accordions";
import Alerts from "../../views/pages/Ui_Interface/Components/Alerts";
import Breadcrumbs from "../../views/pages/Ui_Interface/Components/Breadcrumbs";
import Avatar from "../../views/pages/Ui_Interface/Components/Avatar";
import Badges from "../../views/pages/Ui_Interface/Components/Badges";
import ButtonCard from "../../views/pages/Ui_Interface/Components/ButtonCard";
import ButtonGroup from "../../views/pages/Ui_Interface/Components/ButtonGroup";
import Cards from "../../views/pages/Ui_Interface/Components/Cards";
import Dropdowns from "../../views/pages/Ui_Interface/Components/Dropdowns";
import Grid from "../../views/pages/Ui_Interface/Components/Grid";
import Images from "../../views/pages/Ui_Interface/Components/Images";
import Media from "../../views/pages/Ui_Interface/Components/Media";
import Modals from "../../views/pages/Ui_Interface/Components/Modals";
import Offcanvas from "../../views/pages/Ui_Interface/Components/Offcanvas";
import Pagination from "../../views/pages/Ui_Interface/Components/Pagination";
import Popover from "../../views/pages/Ui_Interface/Components/Popover";
import Progress from "../../views/pages/Ui_Interface/Components/Progress";
import Placeholder from "../../views/pages/Ui_Interface/Components/Placeholder";
import RangeSlider from "../../views/pages/Ui_Interface/Components/RangeSlider";
import Spinners from "../../views/pages/Ui_Interface/Components/Spinners";
import SweetAlert from "../../views/pages/Ui_Interface/Components/SweetAlert";
import Tabs from "../../views/pages/Ui_Interface/Components/Tabs";
import Toats from "../../views/pages/Ui_Interface/Components/Toats";
import Typography from "../../views/pages/Ui_Interface/Components/Typography";
import Videos from "../../views/pages/Ui_Interface/Components/Videos";
import Lightbox from "../../views/pages/Ui_Interface/Components/Lightbox";
import Carousel from "../../views/pages/Ui_Interface/Components/Carousel";
import Borders from "../../views/pages/Ui_Interface/Components/Borders";
import Breadcrumb from "../../views/pages/Ui_Interface/Components/Breadcrumb";
import Colors from "../../views/pages/Ui_Interface/Components/colors";
import UiModals from "../../views/pages/Ui_Interface/Components/uimodals";
import Spinner from "../../views/pages/Ui_Interface/Components/Spinner";
import Tooltips from "../../views/pages/Ui_Interface/Components/Tooltip";
import LoginN from "../../views/pages/Authentication/LoginN";
import ComposeWindowPage from "../../views/pages/Outlook/ComposeWindowPage";
import { useNavigate } from 'react-router-dom';
// useDispatch and setCredentials removed — hardcoded credentials were a security risk



const parseJwt = (token) => {
  try {
    // Split the token and decode the payload
    const payload = atob(token.split('.')[1]);
    return JSON.parse(payload);
  } catch (e) {
    return null;
  }
};

const RedirectHandler = () => {
  const history = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      clearLocalStorageSafe();
      history('/');
      return;
    }

    const decodedToken = parseJwt(token);

    if (!decodedToken) {
      clearLocalStorageSafe();
      history('/');
      return;
    }

    const currentTime = Date.now() / 1000; 

    // Check if the token has expired
    if (decodedToken.exp < currentTime) {
      clearLocalStorageSafe();
      history('/');
      return;
    }

    // If there are missing fields or any modification is detected
    if (decodedToken.exp === undefined) {
      clearLocalStorageSafe();
      history('/');
      return;
    }
  }, [history]);

  return null;
};


const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRouter = () => {
  // Hardcoded credentials removed — was a security risk and no component reads state.task.email/password

  return (
    <div>
        <BrowserRouter basename="/">
          <ScrollToTop />
          <RedirectHandler />
          <Routes>
            {/* <Route path="/" element={<Login />} /> */}
            <Route path="/" element={<LoginN />} />

            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/error-404" element={<Error404 />} />
            <Route path="/error-500" element={<Error500 />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/lock-screen" element={<LockScreen />} />
            <Route path="/accordion" element={<Accordions />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/breadcrumbs" element={<Breadcrumbs />} />
            <Route path="/avatar" element={<Avatar />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/buttons" element={<ButtonCard />} />
            <Route path="/buttongroup" element={<ButtonGroup />} />
            <Route path="/cards" element={<Cards />} />
            <Route path="/dropdowns" element={<Dropdowns />} />
            <Route path="/grid" element={<Grid />} />
            <Route path="/images" element={<Images />} />
            <Route path="/media" element={<Media />} />
            <Route path="/modal" element={<Modals />} />
            <Route path="/offcanvas" element={<Offcanvas />} />
            <Route path="/pagination" element={<Pagination />} />
            <Route path="/popover" element={<Popover />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/placeholders" element={<Placeholder />} />
            <Route path="/rangeslider" element={<RangeSlider />} />
            <Route path="/spinners" element={<Spinners />} />
            <Route path="/sweetalert" element={<SweetAlert />} />
            <Route path="/nav-tabs" element={<Tabs />} />
            <Route path="/toastr" element={<Toats />} />
            <Route path="/tooltips" element={<Tooltips />} />
            <Route path="/typography" element={<Typography />} />
            <Route path="/video" element={<Videos />} />
            <Route path="/lightbox" element={<Lightbox />} />
            <Route path="/carousel" element={<Carousel />} />
            <Route path="/carousel" element={<Carousel />} />
            <Route path="/borders" element={<Borders />} />
            <Route path="/breadcrumb" element={<Breadcrumb />} />
            <Route path="/colors" element={<Colors />} />
            <Route path="/modals" element={<UiModals />} />
            <Route path="/spinner" element={<Spinner />} />
            {/* Standalone compose popup window — must be before the /* catch-all */}
            <Route path="/compose-window" element={<ComposeWindowPage />} />
            {/* Webtop is now the ONLY shell (legacy tab view retired at cutover). */}
            <Route path="/webtop" element={<WebtopPreview />} />
            {/* Legacy shell archived for rollback — to restore, swap the line below
                back to: <Route path="/*" element={<AppContainer />} /> */}
            <Route path="/*" element={<Navigate to="/webtop" replace />} />

            {/* <Route path="*" element={<Navigate to="/" />} /> */}
            <Route path="/GeneratePassword" element={<ChangePassword />} />
          </Routes>
        </BrowserRouter>
    </div>
  );
};

export default AppRouter;
